import exercise1 from './i18n/exercise1';
import exercise2 from './i18n/exercise2';
import exercise3 from './i18n/exercise3';
import CourseController from '../../../../../components/diagrams/course.controller';

class DefineProblemController extends CourseController {

  constructor(courseService, helperService, $sce, $scope) {
    "ngInject";
    super(courseService, helperService, $sce, $scope);
    Object.assign(this, { helperService, $sce });
    this.videoUrl = this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322793936');
    let lang = 'en';
    this.exercise1 = exercise1[lang];
    this.exercise2 = exercise2[lang];
    this.exercise3 = exercise3[lang];

    this.deafultPyramidData = {
      scheme: {
        model: {
          textarea: '',
        },
        children: [{}, {}, {}],
      },
      scq: {
        s: '',
        c: '',
        q: ''
      },
    };
    this.isUnit = true
    this.isCompleted = {}
    this.complexExercises = {
      1: {
        attempts: 0,
        hintsUsed: 0,
        rightAnswers: 0
      },
      2: {
        attempts: 0,
        hintsUsed: 0,
        rightAnswers: 0
      }
    }
  }

  courseDataReceived () {
    super.courseDataReceived()
    if (this.isCompleted['1']) {
      this.showAdditionalBlock1 = true
    }
    if (this.isCompleted['2']) {
      this.defineScqAnswers('exercise3', {
        howToDefineAProblem: {
          scq: {
            s: 'Unable to finish Rationalization Program in time allotted',
            c: 'Clearly must be cut, but want to achieve maximum savings possible',
            q: 'How cut?'
          }
        }
      }, 'howToDefineAProblem', true)
    }
    this.$scope.$apply();
  }

  onSubmitScqDiagramDndFramework (nextExercise, nextExerciseLink, pyramidData) {
    if ((this.isCompleted['1'] && nextExercise === 'exercise2') || (nextExercise === 'exercise3' && this.isCompleted['2'])) {
      return
    }
    super.onSubmitScqDiagramDndFramework(nextExercise, nextExerciseLink, pyramidData)
  }

  onClosePyramidBuilder(event) {
    if (!this.isActivePyramidBuilderDemo) return;
    if (this.nextExercise === 'exercise3') {
      this.onFinishExercise('2')
      super.onClosePyramidBuilder(event)
    } else {
      this.isActivePyramidBuilderDemo = false;
      if (this.nextExercise !== 'exercise2') {
        this.showNextExercise()
      } else {
        this.showAdditionalBlock1 = true
        this.onFinishExercise('1')
      }
    }
  }

}

export default DefineProblemController;



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5a/defineProblem/defineProblem.controller.js